import React from "react";
import { Container } from "react-bootstrap";

export default function VenueTable({ venues }) {
  return (
    <Container style={{ padding: "20px" }}>
      <table
        className="table table-bordered"
        style={{
          border: "2px solid black",
          borderCollapse: "collapse",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px", // Added rounded border
          overflow: "hidden", // Ensures the border radius is applied properly
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                border: "1px solid black",
              }}
            >
              District
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                border: "1px solid black",
              }}
            >
              Venue
            </th>
            <th
              style={{
                textAlign: "center",
                backgroundColor: "black",
                color: "white",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                border: "1px solid black",
              }}
            >
              Game
            </th>
          </tr>
        </thead>
        <tbody>
          {venues &&
            Object.keys(venues).map((category, index) =>
              venues[category].map((venue, venueIndex) => (
                <React.Fragment key={`${index}-${venueIndex}`}>
                  <tr>
                    {venueIndex === 0 && (
                      <td
                        rowSpan={venues[category].reduce(
                          (sum, v) => sum + v.games.length,
                          0
                        )}
                        style={{
                          verticalAlign: "middle",
                          textAlign: "center",
                          boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                          border: "1px solid black",
                        }}
                      >
                        {category}
                      </td>
                    )}
                    <td
                      style={{
                        verticalAlign: "middle",
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                        border: "1px solid black",
                      }}
                      rowSpan={venue.games.length}
                    >
                      {venue.venue}
                    </td>
                    <td
                      style={{
                        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                        border: "1px solid black",
                      }}
                    >
                      {venue.games[0]}
                    </td>
                  </tr>
                  {venue.games.slice(1).map((game, gameIndex) => (
                    <tr key={`${index}-${venueIndex}-${gameIndex}`}>
                      <td
                        style={{
                          boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.5)",
                          border: "1px solid black",
                        }}
                      >
                        {game}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))
            )}
        </tbody>
      </table>
    </Container>
  );
}
